var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormBaseElement, XbpmContext, SCROLL_TO_ERROR, } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties, prefixValue, findErrorField } from '../../common';
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { zip, isNil } from 'ramda';
var isTabsDefinitionForSkip = function (prev, next) {
    return FormBaseElement.isDefinitionForSkip(prev, next) &&
        !!zip(prev.elements, next.elements).find(function (it) { return FormBaseElement.isDefinitionForSkip(it[0], it[1]); });
};
var TabsContainer = /** @class */ (function (_super) {
    __extends(TabsContainer, _super);
    function TabsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.getClass = function (item) {
            var _a = item.frontOptions, frontOptions = _a === void 0 ? {} : _a;
            var _b = frontOptions.className, className = _b === void 0 ? '' : _b;
            return {
                className: ("" + mapElementClass(frontOptions) + (item.printable === false ? ' HideForPrint' : '') + prefixValue(className, ' ')).trim(),
            };
        };
        _this.handleErrorBound = _this.handleErrorEvent.bind(_this);
        return _this;
    }
    TabsContainer.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        XbpmContext.getContext().on(SCROLL_TO_ERROR, this.handleErrorBound);
    };
    TabsContainer.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        XbpmContext.getContext().off(SCROLL_TO_ERROR, this.handleErrorBound);
    };
    TabsContainer.prototype.handleErrorEvent = function (errors) {
        var _this = this;
        var _a = this.state.def, frontOptions = _a.frontOptions, elements = _a.elements;
        var mode = frontOptions.mode;
        var highlightedError = Object.keys(errors)[0];
        var findErrorTabIndex = function (tabs, id) {
            var errorTabIndex;
            if (tabs && tabs.length) {
                tabs.forEach(function (tab, i) {
                    if (tab.$type === 'block') {
                        if (findErrorField(tab.elements, id)) {
                            errorTabIndex = i;
                        }
                    }
                });
            }
            return errorTabIndex;
        };
        var haveErrorsHiddenInAccordion = function (tab, errs) {
            if (tab.$type === 'block') {
                return Object.keys(errs).some(function (errKey) { return findErrorField(tab.elements, errKey) && isNil(_this.state.activeIndex); });
            }
        };
        var tabWithErrorIndex = mode === 'tab' && highlightedError && findErrorTabIndex(elements, highlightedError);
        if ((tabWithErrorIndex || tabWithErrorIndex === 0) && tabWithErrorIndex !== this.state.activeIndex) {
            console.log('tab_index_update');
            this.setState({ activeIndex: tabWithErrorIndex }, this.forceUpdate);
            this.handleActiveIndexChange(tabWithErrorIndex);
        }
        if (mode === 'accordion' && highlightedError && haveErrorsHiddenInAccordion(this.state.def, errors)) {
            console.log('accordion_index_update');
            this.setState({ activeIndex: 0 }, this.forceUpdate);
            this.handleActiveIndexChange(0);
        }
    };
    TabsContainer.prototype.shouldDefinitionSkip = function (prev, next) {
        return isTabsDefinitionForSkip(prev, next);
    };
    TabsContainer.prototype.elementRender = function (def) {
        var frontOptions = def.frontOptions, hidden = def.hidden, header = def.header;
        if (hidden) {
            return null;
        }
        var mode = frontOptions.mode, isPrintableHeader = frontOptions.isPrintableHeader, style = frontOptions.style;
        return (React.createElement("div", __assign({}, this.getClass(def), { style: style }),
            React.createElement("div", { className: 'tabs-block' + (isPrintableHeader === false ? ' HideForPrint' : ''), style: { textAlign: 'center', fontWeight: 'bold' } }, (header || frontOptions.header) && (React.createElement(React.Fragment, null,
                header || frontOptions.header,
                React.createElement("hr", null)))),
            mode === 'accordion' ? this.renderAccordion(def) : this.renderTabs(def)));
    };
    TabsContainer.prototype.renderTabContent = function (tab) {
        var _this = this;
        return tab.elements.map(function (it) { return _this.renderChild(it); });
    };
    TabsContainer.prototype.renderTabs = function (def) {
        var _this = this;
        var id = def.id, frontOptions = def.frontOptions;
        var properties = omitSpecialProperties(frontOptions);
        return (React.createElement(TabView, __assign({ key: id, id: id, activeIndex: typeof this.state.activeIndex !== 'number' ? 0 : this.state.activeIndex, onTabChange: function (e) {
                _this.handleActiveIndexChange(e.index);
            } }, properties), this.renderTabsChildren(def)));
    };
    TabsContainer.prototype.renderTabsChildren = function (def) {
        var _this = this;
        var tabs = def.elements;
        return tabs
            .filter(function (it) { return !it.hidden; })
            .map(function (it) {
            var frontOptions = it.frontOptions, header = it.header, id = it.id, disabled = it.disabled;
            var properties = omitSpecialProperties(frontOptions);
            return (React.createElement(TabPanel, __assign({}, properties, { id: id, key: id, header: header || frontOptions.header, disabled: disabled }), _this.renderTabContent(it)));
        });
    };
    TabsContainer.prototype.renderAccordion = function (def) {
        var _this = this;
        var id = def.id, frontOptions = def.frontOptions;
        var properties = omitSpecialProperties(frontOptions);
        return (React.createElement(Accordion, __assign({ key: id, id: id, activeIndex: this.state.activeIndex, onTabChange: function (e) {
                _this.handleActiveIndexChange(e.index);
            } }, properties), this.renderAccordionChildren(def)));
    };
    TabsContainer.prototype.renderAccordionChildren = function (def) {
        var _this = this;
        var tabs = def.elements;
        return tabs
            .filter(function (it) { return !it.hidden; })
            .map(function (it) {
            var frontOptions = it.frontOptions, header = it.header, id = it.id, disabled = it.disabled;
            var properties = omitSpecialProperties(frontOptions);
            return (React.createElement(AccordionTab, __assign({}, properties, { id: id, key: id, header: header || frontOptions.header, disabled: disabled }), _this.renderTabContent(it)));
        });
    };
    return TabsContainer;
}(FormBaseElement));
export { TabsContainer };
//# sourceMappingURL=Tabs.js.map